(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dtb-faq-paper-types"] && !Shopify.designMode) return;
  try {
    
  function filterPaperFaq(type, sectionId) {
    const tabs = document.querySelectorAll(`#dtb-faq-paper-${sectionId} .dtb-faq-paper__tab`);
    const items = document.querySelectorAll(`#faq-list-${sectionId} .dtb-faq-paper-item`);
    
    // Update tabs
    tabs.forEach(tab => {
      const isActive = tab.id === `tab-${type}-${sectionId}`;
      tab.classList.toggle('dtb-faq-paper__tab--active', isActive);
      tab.setAttribute('aria-selected', isActive);
    });
    
    // Filter items
    items.forEach(item => {
      if (type === 'all' || item.dataset.paperType === type) {
        item.style.display = 'block';
        item.removeAttribute('hidden');
      } else {
        item.style.display = 'none';
        item.setAttribute('hidden', '');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtb-reviews"] && !Shopify.designMode) return;
  try {
    
  // Optional: Auto-scroll functionality for reviews
  class ReviewsSlider {
    constructor(element) {
      this.slider = element.querySelector('.dtb-reviews__slider');
      this.track = element.querySelector('.dtb-reviews__track');
      if (!this.slider || !this.track) return;
      
      this.cards = this.track.querySelectorAll('.dtb-review-card');
      if (this.cards.length < 2) return;
      
      // Auto-scroll only on mobile
      if (window.innerWidth < 750) {
        this.initAutoScroll();
      }
    }
    
    initAutoScroll() {
      let scrollInterval;
      let isPaused = false;
      
      const startScroll = () => {
        if (isPaused) return;
        scrollInterval = setInterval(() => {
          const { scrollLeft, scrollWidth, clientWidth } = this.slider;
          if (scrollLeft + clientWidth >= scrollWidth - 10) {
            this.slider.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            this.slider.scrollBy({ left: 300, behavior: 'smooth' });
          }
        }, 4000);
      };
      
      this.slider.addEventListener('touchstart', () => {
        isPaused = true;
        clearInterval(scrollInterval);
      });
      
      this.slider.addEventListener('touchend', () => {
        isPaused = false;
        setTimeout(startScroll, 2000);
      });
      
      // Respect reduced motion preference
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        startScroll();
      }
    }
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.dtb-reviews').forEach(el => new ReviewsSlider(el));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
